<template>
  <div>
    <loading 
      :active.sync="isLoading" 
      color="#85344c"
    ></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Uniodontos</li>
        </ol>

        <div class="row">
          <div class="col-md-12" v-if="mostraErro">
            <div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Ops!</strong>
              <span>{{erroMensagem}}</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <router-link to="uniodontos/criar-uniodonto"  class="btn_1 medium pull-right mb-3">Criar Uniodonto</router-link>
          </div>
        </div>

        <v-card>
          <v-card-title>Seus Planos
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="uniodontos" :search="search">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.cnpj}}</td>
              <td>{{ props.item.email}}</td>
              <td>{{ (props.item.deleted_at) ? 'Desativada' : 'Ativa'}}</td>
              <td class="text-xs-right">
                <router-link
                  :to="'/adm/uniodontos/'+props.item.id"
                >
                <span class="btn_1 gray delete wishlist_close button-content">
                  <i class="fa fa-fw fa-edit"></i> Detalhes
                </span>
                </router-link>
              </td>
              <td class="text-xs-right">
                <router-link
                  :to="'/adm/marketing/'+props.item.id"
                >
                <span class="btn_1 blue delete wishlist_close button-content mt-1 mb-1">
                  <i class="fa fa-pie-chart"></i> Detalhes de Marketing
                </span>
                </router-link>
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >Sua consulta para "{{ search }}" não teve resultado.</v-alert>
          </v-data-table>
        </v-card>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from "axios";
import moment from "moment";
export default {
  mixins: [funcoesGerais],
  data() {
    return {
      search: "",
      erroMensagem: "",
      mostraErro: false,
      headers: [
        { text: "ID", value: "id" },
        { text: "Uniodonto", value: "name" },
        { text: "CNPJ", value: "cnpj" },
        { text: "Contato", value: "email" },
        { text: "Status", value: "deleted_at" },
        { text: "Opções", value: "" },
        { text: "Marketing", value: "" }
      ],
      uniodontos: [],
      isLoading: false
    };
  },
  created() {
    var self = this;
    var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
    if (user) {
     self.isLoading = true;
     ajax("get", "/operadoras")
       .then(response => {
        self.isLoading = false;
        self.uniodontos = response;
       })
       .catch(error => {
         self.isLoading = false;
         tratamento_requisicao(error, this);
       });
    } else {
      self.$router.replace(self.$route.query.redirect || "/");
    }
  }
};
</script>
<style>
    .button-content {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-around;
    }
</style>